import { DataTableHeader } from "vuetify";

export enum GridColumnTypes {
  Text,
  Interger,
  Number,
  Currency,
  Dropdown,
  Boolean,
  Color,
  FileAny,
  Date,
  DateTime,
  Chips,
  Contains,
  Calc
}

export class GridColumn implements DataTableHeader {
  text: string = "";
  value: string = "";
  align?: "start" | "center" | "end" | undefined;
  sortable?: boolean | undefined;
  filterable?: boolean | undefined;
  divider?: boolean | undefined;
  class?: string | string[] | undefined;
  width?: string | number | undefined;
  filter?:
    | ((value: any, search: string | null, item: any) => boolean)
    | undefined;
  sort?: import("vuetify").DataTableCompareFunction<any> | undefined;
  hidden?: boolean = false;
  editable: boolean = true;
  editableClass?: string | undefined;
  editableRules?: any[] = [];
  type: GridColumnTypes = GridColumnTypes.Text;
  hasAttr?: boolean = false; 
  arg?: any | null = null;

  constructor(text: string, value: string, type: GridColumnTypes) {
    this.text = text;
    this.value = value;
    this.type = type;
  }
}

export class GridAction {
  title: string = "";
  icon: string = "";
  visible: ((current: any) => boolean) | undefined;
}

export class GridActionEvent {
  action: string = "";
  item: any;

  constructor(_action: string, _item: any) {
    this.action = _action;
    this.item = _item;
  }
}
